import { apiHelper } from "../redux/apiHelper";

// Get all sections at once (optimized)
export const getAllSubscribePageSections = async () => {
  try {
    let res = await apiHelper("get", `/api/admin/subscribe-page/all-sections`);
    if (res) {
      return res;
    }
  } catch (e) {
    console.log(e);
  }
};

// Get all sections (legacy - for backward compatibility)
export const getSubscribePageSections = async (sectionType) => {
  try {
    let res = await apiHelper("get", `/api/admin/subscribe-page/sections?type=${sectionType || ""}`);
    if (res) {
      return res;
    }
  } catch (e) {
    console.log(e);
  }
};

// Get single section by ID
export const getSubscribePageSectionById = async (id, sectionType) => {
  try {
    let res = await apiHelper("get", `/api/admin/subscribe-page/section/${id}?type=${sectionType}`);
    if (res) {
      return res;
    }
  } catch (e) {
    console.log(e);
  }
};

// Add section
export const addSubscribePageSection = async (data, sectionType) => {
  try {
    let res = await apiHelper("post", `/api/admin/subscribe-page/section/create?type=${sectionType}`, data);
    if (res) {
      return res;
    }
  } catch (e) {
    console.log(e);
  }
};

// Update section
export const updateSubscribePageSection = async (id, data, sectionType) => {
  try {
    let res = await apiHelper("post", `/api/admin/subscribe-page/section/update/${id}?type=${sectionType}`, data);
    if (res) {
      return res;
    }
  } catch (e) {
    console.log(e);
  }
};

// Delete section
export const deleteSubscribePageSection = async (id, sectionType) => {
  try {
    let res = await apiHelper("delete", `/api/admin/subscribe-page/section/delete/${id}?type=${sectionType}`);
    if (res) {
      return res;
    }
  } catch (e) {
    console.log(e);
  }
};
